import merchant from './merchant';

const resolvers = {
  Merchant: {...merchant},
};

export default resolvers;
